import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4eae88b1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "E808D2RenderContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下列图中，按照图例区给出的边与对应角颜色的规则来判断存在有误的地方", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请找出错误，并点击第一行中对应的错误点所对应的符号", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "然后在第二行选择应该修正的颜色，使得修正后的图形符合图例规则", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "边与对应角符号颜色", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "中心圆圈", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全同", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "50",
  height: "50"
}, [/*#__PURE__*/_createElementVNode("circle", {
  cx: "25",
  cy: "25",
  r: "20",
  stroke: "red",
  fill: "none",
  "stroke-width": "3"
})], -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "一同", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "50",
  height: "50"
}, [/*#__PURE__*/_createElementVNode("circle", {
  cx: "25",
  cy: "25",
  r: "20",
  stroke: "green",
  fill: "none",
  "stroke-width": "3"
})], -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全不同", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "50",
  height: "50"
}, [/*#__PURE__*/_createElementVNode("circle", {
  cx: "25",
  cy: "25",
  r: "20",
  stroke: "blue",
  fill: "none",
  "stroke-width": "3"
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_E808D2Triangle = _resolveComponent("E808D2Triangle");
  const _component_E808D2AnswerBtn = _resolveComponent("E808D2AnswerBtn");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString((($props.data[$props.data.length - 1].questionIndex + 1) / 4).toFixed(0)) + "组", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$props.reviewMode ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {
          "background": "#1388ff",
          "color": "white"
        },
        class: "ptr opd6 brd4",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
      }, "结束回看")) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_4, _hoisted_5, _hoisted_6]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "bothCenter wd100 boldFont"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 11,
        class: "flex justify-end items-center"
      }, {
        default: _withCtx(() => [_hoisted_7]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 2,
        class: "flex items-center"
      }, {
        default: _withCtx(() => [_hoisted_8]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 11,
        class: "flex items-center"
      }, {
        default: _withCtx(() => [_hoisted_9]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "bothCenter wd100 mt16"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 11,
        class: "flex justify-end items-center"
      }, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 2,
        class: "flex items-center"
      }, {
        default: _withCtx(() => [_hoisted_11]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 11,
        class: "flex items-center"
      }, {
        default: _withCtx(() => [_hoisted_12]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "bothCenter wd100"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 11,
        class: "flex justify-end items-center"
      }, {
        default: _withCtx(() => [_hoisted_13]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 2,
        class: "flex items-center"
      }, {
        default: _withCtx(() => [_hoisted_14]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 11,
        class: "flex items-center"
      }, {
        default: _withCtx(() => [_hoisted_15]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "bothCenter wd100"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 11,
        class: "flex justify-end items-center"
      }, {
        default: _withCtx(() => [_hoisted_16]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 2,
        class: "flex items-center"
      }, {
        default: _withCtx(() => [_hoisted_17]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 11,
        class: "flex items-center"
      }, {
        default: _withCtx(() => [_hoisted_18]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, q => {
      return _openBlock(), _createBlock(_component_el_col, {
        span: 6,
        class: "mt32 flex flex-col bothCenter",
        key: q.questionIndex
      }, {
        default: _withCtx(() => [_createVNode(_component_E808D2Triangle, {
          colors: q.question
        }, null, 8, ["colors"]), (_openBlock(), _createBlock(_component_E808D2AnswerBtn, {
          data: q.question,
          key: `ans_${q.questionIndex}`,
          review: $props.review ? $props.review[q.questionIndex] : null,
          answer: $props.review ? q.rightAnswer : null,
          onAnswer: v => $options.onSelectAnswer(q.questionIndex, v)
        }, null, 8, ["data", "review", "answer", "onAnswer"]))]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })]);
}